import type { PropertyTree } from '@cognite/apm-client';
import type { Filters } from '@cognite/fdm-client';

import {
  CHECKLIST_MEASUREMENTS_RELATION_LIMIT,
  TEMPLATE_TASK_LIMIT,
} from '../../template/constants';

export type BuildChecklistItemsPropertyTreeOptions = {
  itemsLimit?: number;
  itemsFilter?: Filters;
  includeObservations?: boolean;
};

const buildDetailItemPropertyTree = (
  includeObservations: boolean
): PropertyTree => ({
  // Nested `limit` is per result set, not per parent item. Direct relations
  // are 0–1 per item, so the cap must cover one asset/timeseries per item.
  asset: { limit: TEMPLATE_TASK_LIMIT },
  files: { limit: TEMPLATE_TASK_LIMIT },
  measurements: {
    limit: CHECKLIST_MEASUREMENTS_RELATION_LIMIT,
    propertyTree: {
      timeseries: { limit: CHECKLIST_MEASUREMENTS_RELATION_LIMIT },
    },
  },
  ...(includeObservations
    ? { observations: { limit: TEMPLATE_TASK_LIMIT } }
    : {}),
});

export const buildChecklistDetailPropertyTree = ({
  itemsLimit = TEMPLATE_TASK_LIMIT,
  itemsFilter,
  includeObservations = false,
}: BuildChecklistItemsPropertyTreeOptions = {}): PropertyTree => ({
  checklistItems: {
    limit: itemsLimit,
    ...(itemsFilter ? { filters: itemsFilter } : {}),
    propertyTree: buildDetailItemPropertyTree(includeObservations),
  },
});
